import { Theme, color, rem, radius } from '@thiememeulenhoff/lit-sdk';
import { css } from 'lit';
import { tagName } from '../../helpers';

export const theme = new Theme(tagName('read-speaker'));

export const hostStyles = css`
  --button-size: ${rem(32)};
  display: block;

  ${theme.props([['margin', 'margin', rem(0, 0, 24, 0)]])};
`;

export const readSpeakerStyles = css`
  align-items: center;
  background-color: ${color('white')};
  display: inline-flex;
`;

export const readSpeakerAsButtonStyles = css`
  ${theme.props([
    ['box-shadow', 'box-shadow', 'var(--tm-elevation-shadow-raised)'],
    ['padding', 'padding', rem(4)],
    ['border-radius', 'border-radius', radius('medium')],
  ])};
`;

export const buttonStyles = css`
  align-items: center;
  block-size: var(--button-size);
  display: flex;
  font-size: 1.25rem;
  inline-size: var(--button-size);
  justify-content: center;

  ${theme.props([
    ['color', 'button-color', color('black')],
    ['border-radius', 'button-border-radius-hover', radius('small')],
    [
      'transition',
      'button-transition',
      'all var(--tm-transition-duration-normal) var(--tm-transition-function-ease-out)',
    ],
  ])};
`;

export const buttonHoverStyles = css`
  ${theme.props([
    ['background', 'button-background-hover', color('blue', 200)],
  ])};
`;
